// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1Dsb2","errorLogs":"styles_errorLogs__2GCWA"};